module.exports = __webpack_public_path__ + "img/yiwuliu.e5c1c861.png";